import { render, staticRenderFns } from "./tsUpload.vue?vue&type=template&id=5de7d8a6&scoped=true&"
import script from "./tsUpload.vue?vue&type=script&lang=ts&"
export * from "./tsUpload.vue?vue&type=script&lang=ts&"
import style0 from "./tsUpload.vue?vue&type=style&index=0&id=5de7d8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de7d8a6",
  null
  
)

export default component.exports